import { useAppStore } from '~/stores/app';

export default function ({$pinia}) {
    const appStore  = useAppStore($pinia);

    appStore.setState({key: 'gainsAllowed', value: true});
}
